import React, { useState, useRef } from "react";

//components
import TextOptionListItem from "./TextOptionListItem";
import { DndProvider } from "react-dnd";
import { TouchBackend } from "react-dnd-touch-backend";
import PanelButton from "../../buttons/PanelButton";

//interfaces
import { IBasicOption, ITextOptionList } from "../../../../interfaces/lists/ITextOptionList";



const TextOptionList = ({optionList, setOptionList, optionListTitle, showOptionListTitle, optionPlaceholderText, optionLimit}: ITextOptionList) => {  
    const containerRef = useRef<HTMLDivElement>(null);
    
    const [hoverIndex, setHoverIndex] = useState<number | null>(null);
    const optionLimitHasBeenMet: boolean = !!optionLimit && optionLimit === optionList.length;
    const hasUnfinishedOptions: boolean = optionList.some(
        (opt) => !opt.text || opt.text.trim() === ""
    );
    const addOptionsIsDisabled = optionLimitHasBeenMet || hasUnfinishedOptions;

    function onAddOptionClick() {
        const maxId = optionList.length > 0 
            ? Math.max(...optionList.map(option => option.id)) 
            : 0;

        const newOption: IBasicOption = {
            id: maxId + 1,
            text: "",
        };

        setOptionList([...optionList, newOption]);
    };

    function onEditOptionText(id: number, text: string) {
        const updatedOptions: IBasicOption[] = optionList.map((option) =>
            option.id === id ? { ...option, text } : option
        );

        setOptionList(updatedOptions);
    };

    function onDeleteOptionClick(optionId: number) {
        const updatedOptionList = optionList.filter(option => option.id !== optionId);
        setOptionList(updatedOptionList);
    };

    function moveListItem(dragIndex: number, hoverIndex: number) {
        const dragRow = optionList[dragIndex];
        const updatedOptionList = [...optionList];
        updatedOptionList.splice(dragIndex, 1);
        updatedOptionList.splice(hoverIndex, 0, dragRow);

        setOptionList(updatedOptionList);
        setHoverIndex(null);
    };


    return (
        <DndProvider backend={TouchBackend} options={{enableMouseEvents: true}}>    
            <div className="text-option-list-container" ref={containerRef}>
                {showOptionListTitle &&
                    <h2>{optionListTitle || "Options"}</h2>
                }

                <ul className={`text-option-list`} > 
                    {optionList.map((option, index) => (
                        <TextOptionListItem 
                            key={`${option.id}-${option.id}`}
                            id={option.id} 
                            text={option.text} 
                            index={index} 
                            onEditOptionText={onEditOptionText}
                            onDeleteOptionClick={() => onDeleteOptionClick(option.id)} 
                            containerRef={containerRef} 
                            moveListItem={moveListItem} 
                            hoverIndex={hoverIndex}
                            setHoverIndex={setHoverIndex} 
                            placeholderText={optionPlaceholderText}               
                        />
                    ))}
                </ul>

                <PanelButton 
                    className="add-option-panel-button"
                    isDisabled={addOptionsIsDisabled}
                    content={"+ Add Option"} 
                    ariaLabel={"Add an option to the list"} 
                    onButtonClick={()=> onAddOptionClick()} 
                />
            </div>
        </DndProvider>
    );
}

export default TextOptionList